<div class="steps">
  @for (step of steps(); track $index) {
    <div class="step">
      <div class="step-counter-line">
        <div class="counter">{{ $index + 1 }}</div>
        @if (!$last) {
          <div class="line"></div>
        }
      </div>
      <div class="step-content">
        <rt-heading>{{ step.heading }}</rt-heading>
        <p [innerHTML]="step.content"></p>
      </div>
    </div>
  }
</div>
